<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-sm-6 text-start mb3">عرض البيانات</div>
        <div class="col-12 col-sm-6 text-end mb3">
          <button v-if="dataRow && !calculateLoader" type="button" @click="calculateContainer" class="btn btn-warning">تجميع القيم المالية</button>
          <loader v-if="dataRow && calculateLoader" />
        </div>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
    <!--begin::Body-->
    <div v-else class="card-body">
      <div class="row steps-container">
        <div class="col" v-for="(title, index) in stepTitles" :key="index">
          <div class="steps" @click="jumbToStep(index + 1)">
            <span :class="{ active: step === index + 1 }">
              {{ title }}
            </span>
          </div>
        </div>
      </div>
      <!-- owner type -->
      <div v-if="step == 1">
        <div v-if="dataRow.Project" class="mb-3">
          <label class="form-label">المشروع العقاري:</label>
          <div>
            <router-link v-if="checkAccess('projects_read')" :to="`/projects/update/${dataRow.Project.id}`">{{ dataRow.Project.title }}</router-link>
            <span v-else>{{ dataRow.Project.title }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label" for="">العميل: <span class="req">*</span></label>
            <div>{{ userMobile }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <loader v-if="userLoader" />
            <div v-if="userName">
              <label class="form-label" for="">اسم العميل:</label>
              <div>{{ userName }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الاساسية:</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع العقار: <span class="req">*</span></label>
            <div>{{ (dataRow.PropertyContainerType)? dataRow.PropertyContainerType.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وصف مختصر: <span class="req">*</span></label>
            <div>{{ title }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات العنوان:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
            <div>{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">المدينة: <span class="req">*</span></label>
            <div>{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحي: <span class="req">*</span></label>
            <div>{{ (dataRow.Neighborhood)? dataRow.Neighborhood.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الموقع على الخريطة:</label>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
            <div class="row pt-2">
              <div class="col">
                <label for="" class="form-label">خط العرض - latitude</label>
                <div>{{ latitude }}</div>
              </div>
              <div class="col">
                <label for="" class="form-label">خط الطول - longitude</label>
                <div>{{ longitude }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataRow" class="row">
          <div class="col"><hr></div>
        </div>
        <div v-if="dataRow" class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات المالية:</div>
          </div>
        </div>
        <div v-if="dataRow" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">ما تم تحصيله:</label>
            <div>{{ collectedAmount }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الدفعات المتبقية:</label>
            <div>{{ remainingPayments }}</div>
          </div>
        </div>
        <div v-if="dataRow" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الدفعات المتأخرة:</label>
            <div>{{ latePayments }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">موعد الدفعة القادمة:</label>
            <div>{{ $shortDate(nextPayment) }}</div>
          </div>
        </div>
      </div>
      <div v-if="step == 2">
        <div v-for="group in additionalGroups" :key="group.title">
          <div class="form-head"><i class="bi bi-chevron-left"></i> {{ group.title }}:</div>
          <div class="row">
            <div v-for="field in group.fields" :key="field.key" class="col-12 col-sm-6 mb-3">
              <label class="form-label">{{ field.label }}</label>
              <div>{{ additionalValue(field.key) }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> المستندات ورقم الصك:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الصك:</label>
            <div>{{ deedNumber }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">صورة هوية المالك:</label>
            <img v-if="uploadedIdentityImage" :src="MEDIA_URL+uploadedIdentityImage" class="img-thumbnail" style="max-width: 200px;" alt="">
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">صورة رخصة البناء:</label>
            <img v-if="uploadedBuildingPermitImage" :src="MEDIA_URL+uploadedBuildingPermitImage" class="img-thumbnail" style="max-width: 200px;" alt="">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">صورة شهادة الدفاع المدني:</label>
            <img v-if="uploadedDefenseCertificateImage" :src="MEDIA_URL+uploadedDefenseCertificateImage" class="img-thumbnail" style="max-width: 200px;" alt="">
          </div>
        </div>

        <PropertyProfile :containerId="dataRow.id" />
      </div>
      <!-- images -->
      <div v-if="step == 3">
        <div class="row">
          <div class="col-12 col-sm-3 media-img-container" v-for="(img, indx) in mediaList" :key="indx">
            <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
          </div>
        </div>
      </div>
      <!-- properties -->
      <div v-if="step == 4">
        <div class="card card-secondary card-outline mb-4 mt-4">
          <div class="card-header"><div class="card-title">الوحدات المدرجة تحت العقار</div></div>
          <div class="card-body">
            <div v-if="!dataRow.Properties?.length" class="text-muted">لا توجد وحدات مدرجة حاليًا.</div>
            <div v-else class="table-responsive">
              <table class="table table-striped align-middle">
                <thead><tr><th>العقار</th><th>الصورة</th><th>الوصف</th><th>السعر</th></tr></thead>
                <tbody>
                  <tr v-for="row in dataRow.Properties" :key="row.id">
                    <td><router-link :to="`/properties/update/${row.id}`">عقار رقم #{{ row.id }}</router-link></td>
                    <td><img v-if="row.mediaFiles?.length" :src="MEDIA_URL + row.mediaFiles[0].thumbnail" class="img-thumbnail" style="max-width: 150px;" alt=""></td>
                    <td><router-link :to="`/properties/update/${row.id}`">{{ row.title }}</router-link></td>
                    <td>{{ row.price ?? 'غير محدد' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 5">
        <PropertyAttachments v-if="dataRow" :containerId="dataRow.id" />
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, shortDate, checkAccess } from '@/helpers/tools';
import PropertyAttachments from '@/components/PropertyAttachments.vue';
import PropertyProfile from '@/components/PropertyProfile.vue';

export default {
  name: 'PropertyContainersView',
  components: { PropertyAttachments, PropertyProfile },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      mainLoading: true,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: ["بيانات العقار", "البيانات الإضافية", "الصور", "الوحدات", "مرفقات العقار"],
      // for config
      regionsList: [],
      typesList: [],
      userMobile: null,
      userName: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      uploadedIdentityImage: null,
      uploadedBuildingPermitImage: null,
      uploadedDefenseCertificateImage: null,
      userId: null,
      identityImage: null,
      buildingPermitImage: null,
      defenseCertificateImage: null,
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      deedNumber: '',
      typeId: null,
      title: '',
      latitude: 24.7136,
      longitude: 46.6753,
      mediaIds: [],
      map: null,
      marker: null,
      collectedAmount: 0,
      remainingPayments: 0,
      nextPayment: null,
      latePayments: 0,
      calculateLoader: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    additionalGroups(){
      return [
        {title: 'بيانات المياه', fields: [{key: 'waterSeparation', label: 'فصل وحدات الماء'}, {key: 'waterAccountNumber', label: 'رقم حساب الماء'}, {key: 'waterMeterNumber', label: 'رقم عداد الماء'}]},
        {title: 'بيانات الكهرباء', fields: [{key: 'electricityAccountNumber', label: 'رقم حساب الكهرباء'}, {key: 'electricityTenantMeterAccount', label: 'رقم حساب عداد الكهرباء للمستأجر'}, {key: 'electricityMeterNumber', label: 'رقم العداد'}, {key: 'electricityMeterSubscription', label: 'رقم اشتراك العداد'}, {key: 'electricityMeterLocationNumber', label: 'رقم موقع عداد الكهرباء'}]},
        {title: 'الكراج', fields: [{key: 'garageCount', label: 'عدد الكراج'}, {key: 'garageRemoteCount', label: 'عدد ريموتات الكراج'}]},
        {title: 'عقد الهيئة العامة للعقار', fields: [{key: 'regaContractNumber', label: 'رقم العقد'}, {key: 'regaContractRenewalDate', label: 'تاريخ تجديد العقد الإلكتروني'}, {key: 'managementContractRenewalDate', label: 'تاريخ تجديد عقد إدارة الأملاك'}]},
      ];
    },
  },
  methods: {
    checkAccess,
    additionalValue(field){
      const value = this.dataRow?.[field];
      if(value === null || value === undefined || value === '') return 'غير محدد';
      if(field === 'waterSeparation') return value ? 'نعم' : 'لا';
      return value;
    },
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 1){
        this.initialGoogleMap();
      }
    },
    nextStep(){
      this.step = this.step + 1;
    },
    getInitData(){
      this.$http.get('/api/admin/propertyContainers/init').then(({data}) => {
        this.regionsList = data.regionsList;
        this.typesList = data.typesList;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 1){
          this.initialGoogleMap();
        }
      }
    },
    calculateContainer(){
      this.calculateLoader = true;
      this.$http.get(`/api/admin/propertyContainers/calculateContainer/${this.dataRow.id}`).then(({data}) => {
        this.collectedAmount = data.row.collectedAmount;
        this.remainingPayments = data.row.remainingPayments;
        this.nextPayment = data.row.nextPayment;
        this.latePayments = data.row.latePayments;
        this.calculateLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    if(this.dataRow){
      // for config
      this.userMobile = (this.dataRow.User)? this.dataRow.User.mobile : null;
      this.userName = (this.dataRow.User)? this.dataRow.User.name : null;
      this.uploadedIdentityImage = this.dataRow.identityImage;
      this.uploadedBuildingPermitImage = this.dataRow.buildingPermitImage;
      this.uploadedDefenseCertificateImage = this.dataRow.defenseCertificateImage;
      if(this.dataRow.PropertyContainerMedia){
        this.dataRow.PropertyContainerMedia.map(m => {
          this.mediaList.push({
            id: m.id,
            path: m.filePath,
          });
          this.mediaIds.push(m.id);
        });
      }
      this.userId = this.dataRow.userId;
      this.regionId = this.dataRow.regionId;
      this.cityId = this.dataRow.cityId;
      this.neighborhoodId = this.dataRow.neighborhoodId;
      this.deedNumber = this.dataRow.deedNumber;
      this.typeId = this.dataRow.typeId;
      this.title = this.dataRow.title;
      this.latitude = (this.dataRow.latitude)? parseFloat(this.dataRow.latitude) : null;
      this.longitude = (this.dataRow.longitude)? parseFloat(this.dataRow.longitude) : null;
      this.collectedAmount = this.dataRow.collectedAmount;
      this.remainingPayments = this.dataRow.remainingPayments;
      this.nextPayment = this.dataRow.nextPayment;
      this.latePayments = this.dataRow.latePayments;
    }

    this.getInitData();
    this.initialGoogleMap();
  }
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
}
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
</style>
